import styled from 'styled-components';

import { pageFrameBase } from '../../styles';

export const FooterWrapper = styled.footer`
    ${pageFrameBase};

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
        bottom: 0;
    }
`;
